(function () {
  "use strict";

  // Approximate Publitas / Publuu chrome heights (toolbar + footer)
  var CHROME_TOP = 48;
  var CHROME_BOTTOM = 52;

  // Cover page width/height. Spread ratio 1.655 → single page ≈ 0.827
  var DEFAULT_PAGE_ASPECT = 0.827;

  function isMobile() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function isTablet() {
    return window.matchMedia("(min-width: 750px) and (max-width: 989px)").matches;
  }

  function padsFor(width) {
    if (isMobile()) return { x: 80, y: 80 };
    if (isTablet()) return { x: 170, y: 70 };
    return { x: 170, y: 80 };
  }

  function pageAspect(container) {
    var raw = container.getAttribute("data-page-aspect") || DEFAULT_PAGE_ASPECT;
    var value = parseFloat(raw);
    if (!(value > 0.2 && value < 5)) value = DEFAULT_PAGE_ASPECT;
    // Spread ratios (e.g. 1.65) → single cover page
    if (value > 1.2) value = value / 2;
    return value;
  }

  /**
   * Size the frame so the embed height-fits the page with `pad.x` side inset
   * (distance from frame edge → catalog page ≈ pad.x).
   * Vertical inset targets pad.y including chrome when possible.
   */
  function frameHeightFor(width, pad, aspect) {
    // Keep a readable page; allow true 170px inset once the column is wide enough
    var minPageW = 160;
    var maxPadX = Math.max(0, (width - minPageW) / 2);
    var padX = Math.min(pad.x, maxPadX);
    var pageW = width - padX * 2;
    var pageH = pageW / aspect;

    // Top/bottom distance from frame edge to page should be pad.y.
    // That distance = chrome + content letterbox.
    var topChrome = CHROME_TOP;
    var botChrome = CHROME_BOTTOM;
    var extraTop = Math.max(0, pad.y - topChrome);
    var extraBot = Math.max(0, pad.y - botChrome);

    // Extra vertical room breaks height-fit (sides collapse). Only add it
    // when the resulting content box still height-fits the page.
    var contentH = pageH;
    var trialExtra = extraTop + extraBot;
    if (trialExtra > 0) {
      var trialContentH = pageH + trialExtra;
      var trialAspect = width / trialContentH;
      if (trialAspect <= aspect) {
        // Still height-fit (or exact) — safe to add vertical extras
        contentH = trialContentH;
      }
    }

    return Math.round(contentH + topChrome + botChrome);
  }

  function fill(el, width, height) {
    if (!el) return;
    el.style.boxSizing = "border-box";
    el.style.width = width + "px";
    el.style.maxWidth = "100%";
    el.style.height = height + "px";
    el.style.minHeight = height + "px";
    el.style.display = "block";
    el.style.border = "0";
    el.style.margin = "0";
  }

  function syncFrame(container) {
    if (!container) return;

    var panel = container.closest(".catalog-embeds__panel");
    var width = (panel && panel.clientWidth) || container.clientWidth;
    if (width < 2) return;

    var pad = padsFor(width);
    var aspect = pageAspect(container);
    var height;

    if (isMobile() || isTablet()) {
      height = frameHeightFor(width, pad, aspect);
      if (panel) {
        panel.style.height = height + "px";
        panel.style.minHeight = height + "px";
      }
      container.style.height = height + "px";

      // Keep left hero the same height as the catalog frame
      var grid = container.closest(".catalog-embeds__grid");
      if (grid && isTablet()) {
        grid.style.height = height + "px";
        grid.style.minHeight = height + "px";
      }

      container.setAttribute("data-pad-x", String(Math.min(pad.x, Math.max(0, (width - 160) / 2))));
      container.setAttribute("data-pad-y", String(pad.y));
      container.setAttribute("data-frame-h", String(height));
    } else {
      if (panel) {
        panel.style.height = "";
        panel.style.minHeight = "";
      }
      container.style.height = "";
      var gridReset = container.closest(".catalog-embeds__grid");
      if (gridReset) {
        gridReset.style.height = "";
        gridReset.style.minHeight = "";
      }
      height = container.clientHeight || (panel && panel.clientHeight) || 550;
    }

    if (height < 2) return;

    var iframe =
      container.querySelector(".catalog-embeds__iframe") ||
      container.querySelector(":scope > iframe") ||
      container.querySelector("iframe");
    var publitas = container.querySelector('[id^="publitas-embed-"]');

    if (iframe) fill(iframe, width, height);

    if (publitas) {
      fill(publitas, width, height);
      var nested = publitas.querySelector("iframe");
      if (nested) fill(nested, width, height);
    }
  }

  function initContainer(container) {
    syncFrame(container);

    if (typeof ResizeObserver === "undefined") return;

    var ticking = false;
    var observer = new ResizeObserver(function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        syncFrame(container);
      });
    });
    observer.observe(container);
    var panel = container.closest(".catalog-embeds__panel");
    if (panel) observer.observe(panel);
  }

  function init() {
    document.querySelectorAll("[data-catalog-embed]").forEach(initContainer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", function () {
    window.setTimeout(init, 300);
    window.setTimeout(init, 1000);
  });

  window.addEventListener("resize", function () {
    document.querySelectorAll("[data-catalog-embed]").forEach(syncFrame);
  });
})();
